import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslateService, Translation } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { PatientService } from '@core/services/patient.service';
import { assets, PROJECTS } from '@core/constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonComponent } from '@shared/components';
import { APIService } from '@core/services';
import { HttpHeaders } from '@angular/common/http';
import { NgOptimizedImage } from '@angular/common';
import { environment } from '@env/environment';

@UntilDestroy()
@Component({
  selector: 'ncp-patient-menu',
  imports: [ButtonComponent],
  templateUrl: './patient-menu.component.html',
  styleUrl: './patient-menu.component.scss',
})
export class PatientMenuComponent implements OnInit {
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  protected readonly router = inject(Router);
  protected translations: Translation = this.translate.instant('patient.menu');
  protected readonly psSrc = assets.img.patient.ps.src;
  protected readonly epSrc = assets.img.patient.ep.src;
  protected readonly orcdSrc = assets.img.patient.orcd.src;
  protected readonly euVacSrc = assets.img.patient.euvac.src;

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('patient.menu');
    });
  }

  protected goToPS = () => {
    if (environment.project === PROJECTS.PROVIDERS) {
      this.router.navigate(['cy', 'patient', 'ps']);
    } else if (environment.project === PROJECTS.BENEFICIARIES) {
      this.router.navigate(['ps']);
    }
  };

  protected goToEP = () => {
    if (environment.project === PROJECTS.PROVIDERS) {
      this.router.navigate(['cy', 'patient', 'ep']);
    } else if (environment.project === PROJECTS.BENEFICIARIES) {
      this.router.navigate(['ep']);
    }
  };

  protected goToORCD = () => {
    if (environment.project === PROJECTS.PROVIDERS) {
      this.router.navigate(['cy', 'patient', 'orcd']);
    } else if (environment.project === PROJECTS.BENEFICIARIES) {
      this.router.navigate(['orcd']);
    }
  };

  protected goToEuVac = () => {
    if (environment.project === PROJECTS.PROVIDERS) {
      this.router.navigate(['cy', 'patient', 'euVac']);
    } else if (environment.project === PROJECTS.BENEFICIARIES) {
      this.router.navigate(['euVac']);
    }
  };

  protected readonly assets = assets;
}
